<template>
    <div class="sportFootballMatchstatusPeriodStopwatch">
      <el-popover
        placement="bottom"
        title="Ajouter ou supprimer du temps"
        width="200"
        trigger="click"
        popper-class="sportFootballMatchstatusPeriodStopwatch"
        @hide="reset">
        <el-input-number v-model="minutes" controls-position="right" :min="-45" :max="+45" size="mini" />
        <el-input-number v-model="seconds" controls-position="right" :min="-59" :max="+59" size="mini" />
        <div class="buttons">
          <el-button size="mini" @click="reset">Annuler</el-button>
          <el-button size="mini" @click="update">Ok</el-button>
        </div>
        <el-button slot="reference">{{ value }}</el-button>
      </el-popover>
    </div>
</template>

<script>
import { stopwatch } from '@/helpers/format'

export default {
  name: 'SportFootballMatchStatusPeriodStopwatch',
  props: {
    start: {
      type: Date,
      required: false
    },
    end: {
      type: Date,
      required: false
    },
    statusId: Number
  },
  data () {
    return {
      minutes: 0,
      seconds: 0
    }
  },
  computed: {
    value () {
      if (this.start) {
        const start = new Date(this.start.getTime())
        start.setSeconds(start.getSeconds() - 60 * this.minutes - this.seconds)
        return stopwatch(start, this.end, this.statusId)
      }
      return null
    }
  },
  methods: {
    reset () {
      this.minutes = 0
      this.seconds = 0
    },
    update () {
      if (this.start) {
        const start = new Date(this.start.getTime())
        start.setSeconds(start.getSeconds() - 60 * this.minutes - this.seconds)
        this.$emit('update', start)
        this.reset()
      }
    }
  }
}
</script>

<style>
.sportFootballMatchstatusPeriodStopwatch .el-popover__reference{
  height:25px;
  border:none;
  background-color:var(--color-background-live);
  color:var(--color-font-live);
  border-radius:12px;
  padding:0 10px;
  text-align: center;
}
.sportFootballMatchstatusPeriodStopwatch.el-popover{
  text-align:center;
  font-size:8px;
  background-color: var(--color-background-grey);
}
.sportFootballMatchstatusPeriodStopwatch.el-popover .buttons{
  margin-top:7px
}
.sportFootballMatchstatusPeriodStopwatch.el-popover .el-popover__title{
  word-break: break-word;
}
.sportFootballMatchstatusPeriodStopwatch.el-popover .el-input-number{
  width:90px;
}
.sportFootballMatchstatusPeriodStopwatch.el-popover .popper__arrow{
  display:none;
}
</style>
